export interface ContactData {
  id: string;
  phone_number?: string;
  first_name?: string;
  last_name?: string;
  company?: string;
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
  disposition_history?: any;
  active_dispositions?: string[];
  is_blocked?: boolean;
  email?: string;
  industry?: string;
  employees?: string;
  notes?: string;
  source?: string;
  internal_notes?: any;
  extra_data?: any;
}

export async function triggerMapCall(contactData: ContactData): Promise<void> {
  const phoneNumber = contactData.phone_number;
  if (!phoneNumber) {
    console.warn('No phone number for contact:', contactData.id);
    return;
  }
  
  console.log('📞 Map call triggered for:', phoneNumber, contactData);
  
  window.dispatchEvent(new CustomEvent('contactSelected', { detail: contactData }));
  
  if ((window as any).setManualDialNumber) {
    (window as any).setManualDialNumber(phoneNumber, contactData);
  }
  
  window.dispatchEvent(new CustomEvent('webrtcSoftphoneSetNumber', { 
    detail: { phoneNumber, contactData } 
  }));
  
  if ((window as any).softphoneHangup) {
    await (window as any).softphoneHangup();
  }
  
  if ((window as any).softphoneDirectCall) {
    const callStarted = (window as any).softphoneDirectCall(phoneNumber, contactData);
    console.log(callStarted ? '📞 Call initiated' : '📞 Sent to dialer');
  }
}

(window as any).triggerMapCall = triggerMapCall;
